let uniqueIdForInputFields = 0;
const getUniqueId = () => {
  const currentId = uniqueIdForInputFields;
  uniqueIdForInputFields += 1;
  return currentId;
};
export const getComponentId = id => `${id}_${getUniqueId()}`;